import { fabric } from 'fabric';

/**
 * Code object class
 *
 */
const LudusCode = fabric.util.createClass(fabric.Group, {
  type: 'ludusCode',

  /**
   * Class constructor
   *
   * @param image
   * @param options
   */
  initialize(image, options = {}) {
    if (!image) {
      // XXX: This should not be here. How do we ensure the loaded image exists before reaching the initializer?
      return;
    }
    this.imageSrc = image.src;
    this.imageObject = new fabric.Image(image, {
      originY: 'center',
      originX: 'center',
      scaleX: 0.5,
      scaleY: 0.5,
    });
    this.callSuper('initialize', [this.imageObject], options);

    // Register events
    this.on('mousedblclick', this.edit.bind(this));
  },

  /**
   * Trigger edition - see registerEditionCallback below
   *
   */
  edit() {
    LudusCode.editionCallback();
  },

  updateCodeAndImage(codeConfig, imageUrl, callback) {
    fabric.util.loadImage(
      imageUrl,
      image => {
        if (!image) {
          console.warn('Failed to load code image');
          return;
        }
        this.imageSrc = image.src;
        const newImageObject = new fabric.Image(image, {
          originY: 'center',
          originX: 'center',
          left: this.imageObject.left,
          right: this.imageObject.right,
          scaleX: this.imageObject.scaleX,
          scaleY: this.imageObject.scaleY,
        });
        this.remove(this.imageObject).add(newImageObject);
        this._calcBounds(true);
        this.setCoords();
        this.imageObject = newImageObject;
        this.ludus = {
          ...this.ludus,
          ...codeConfig,
          imageUrl: image.src,
        };

        if (this.canvas) {
          this.canvas.requestRenderAll();
        }

        if (callback) {
          callback(this); // eslint-disable-line standard/no-callback-literal
        }
      },
      null,
      'Anonymous',
    );
  },

  /**
   * Override fabric.Group.toObject() to include the reference
   *
   * @returns {Object}
   */
  toObject(propertiesToInclude = []) {
    const extraProps = ['imageSrc'];
    const object = this.callSuper(
      'toObject',
      propertiesToInclude.concat(extraProps),
    );
    delete object.objects;

    return object;
  },
});

LudusCode.fromObject = (object, callback) => {
  const options = fabric.util.object.clone(object, true);
  const { imageSrc } = options;

  delete options.imageSrc;

  fabric.util.loadImage(
    imageSrc,
    imageElement => {
      if (callback) {
        const code = new LudusCode(imageElement, options);
        callback(code);
      }
    },
    null,
    'Anonymous',
  );
};

/**
 * As the edition will require the dispatching of a redux action, we will let an action creator
 * (see symbolActions.registerSymbols) register it.
 *
 * @param callback
 */
LudusCode.registerEditionCallback = callback => {
  LudusCode.editionCallback = callback;
};

export default LudusCode;
